import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'redux';
import useLocalStorage from 'chameleon/packages/blue-book-player/hooks/use-local-storage';
import log from 'chameleon/packages/blue-book-player/utility/log';
import ButtonWithIcon from '../button-with-icon';

const MarkForReview = ({ params, learnosityItemReference, userId }) => {
  const assignmentId = params?.assignmentId;

  const [isMarked, setIsMarked] = useState(false);
  const [saveItem, , getItem] = useLocalStorage({
    key: 'qnMark',
    itemKey: `${userId}-${assignmentId}`,
  });

  const getMarkedQuestions = () => {
    try {
      return JSON.parse(getItem() ?? '[]');
    } catch (error) {
      log('error', error);
      return [];
    }
  };

  const getMarkedState = (markedQuestions) =>
    markedQuestions.includes(learnosityItemReference);

  const updateLocalStorage = (newMarkedStatus) => {
    const localStorageMarkedQuestions = getMarkedQuestions();
    const updatedMarkedQuestions = newMarkedStatus
      ? [...localStorageMarkedQuestions, learnosityItemReference]
      : localStorageMarkedQuestions.filter(
          (id) => id !== learnosityItemReference,
        );
    try {
      saveItem(JSON.stringify(updatedMarkedQuestions));
    } catch (error) {
      log('error', error);
    }
  };

  const onToggleMark = () => {
    setIsMarked((currentMarkedStatus) => {
      const newMarkedStatus = !currentMarkedStatus;
      updateLocalStorage(newMarkedStatus);

      return newMarkedStatus;
    });
  };

  useEffect(() => {
    const markedQuestions = getMarkedQuestions();
    setIsMarked(getMarkedState(markedQuestions));
  }, []);

  const accessibilityProps = {
    'aria-label': 'Mark for review',
    'aria-pressed': isMarked,
  };
  const iconAccessibility = {
    'aria-hidden': true,
  };

  return (
    <ButtonWithIcon
      icon="bookmark"
      onClick={onToggleMark}
      iconOrientation="left"
      iconClassName={isMarked ? 'text-bluebook-red1' : 'fill-white'}
      iconAccessibility={iconAccessibility}
      containerClassName={isMarked ? 'font-bold' : ''}
      data-cy="mark-for-review-button"
      {...accessibilityProps}
    >
      Mark for Review
    </ButtonWithIcon>
  );
};

const mapStateToProps = (state) => ({
  userId: state?.userData?.me?.initId,
});

export default compose(withRouter, connect(mapStateToProps))(MarkForReview);
